import { addMinutes } from "date-fns";
import { AppData } from "../../AppDataProvider/AppDataProvider";
import { emitEvent } from "../../utils";

export const emitBookingCreatedEvent = function (appData: AppData) {
  if (appData.iFrameId && appData.bookingData.confirmedBookingIds) {
    const startTime = appData.bookingData.startDate;
    let endTime = undefined;

    if (startTime && appData.bookingData.duration?.minutes) {
      endTime = addMinutes(startTime, appData.bookingData.duration?.minutes);
    }

    const data = {
      customer: appData.bookingData.userDetails,
      end_time: endTime,
      id: appData.bookingData.confirmedBookingIds[
        appData.bookingData.confirmedBookingIds?.length - 1
      ],
      organisation_id: appData.bookingData.organisation?._id,
      organisation_name: appData.bookingData.organisation?.name,
      resource_id: appData.bookingData.resource?._id,
      service_id: appData.bookingData.service?._id,
      service_name: appData.bookingData.service?.name,
      spaces: appData.bookingData.attendees,
      start_time: startTime,
      timezone: appData.bookingData.timezone,
    };

    emitEvent({
      data: {
        booking: data,
        iFrameId: appData.iFrameId,
      },
      name: "BOOKING_CREATED",
    });
  }
};
